export const mapProcurementUnitToFrontend = (unit?: string): string | undefined => {
  if (unit === 'KW') return 'kW'
  if (unit === 'KWh') return 'kWh'
  return unit
}
